module.exports = __webpack_public_path__ + "img/weibo_black.e682d56c.png";